// src/pwa.ts — Registro del service worker para que el panel sea instalable.
// El SW (public/sw.js) es mínimo y NO cachea el shell (la actualización la maneja
// autoUpdate.ts). Solo registrarlo habilita "Instalar app" en Chrome/Android y
// "Agregar a inicio" en iOS.

export function registerPwa(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* sin SW: el panel sigue funcionando igual, solo no será instalable */
    });
  });
}
